import React, { useState } from 'react';
import { useAuth } from '../../../shared/contexts/AuthContext';
import PortalHeader from '../components/PortalHeader';
import TravelPaymentPortalSection from '../components/TravelPaymentPortalSection';
import Dashboard from '../../../components/portal/dashboard/Dashboard';
import type { TravelPaymentPortalProps, LoginFormData } from '../types/travel-payment';
import '../../../styles/travel-payment-portal.css';

const TravelPaymentPortalComponent: React.FC<TravelPaymentPortalProps> = ({
  className = ''
}) => {
  const { isAuthenticated, login } = useAuth();
  const [loginError, setLoginError] = useState<string>('');

  const handleLogin = async (formData: LoginFormData) => {
    console.log('Login attempt:', formData);
    setLoginError('');
    
    try {
      const success = await login(formData.username, formData.password);
      if (!success) {
        setLoginError('Invalid credentials. Please use: ervin.broker / password123');
      }
    } catch {
      setLoginError('Login failed. Please try again.');
    }
  };

  const handleResetPasswordSubmit = (email: string) => {
    console.log('Reset password for:', email);
    alert(`Reset link would be sent to: ${email}`);
  };

  const handleDownloadGuide = () => {
    console.log('Downloading user guide...');
    alert('User Guide download would start here');
  };

  // If authenticated, show the dashboard with travel-payment theme
  if (isAuthenticated) {
    return <Dashboard className={className} theme="travel-payment" />;
  }

  // If not authenticated, show the login form
  return (
    <div className={`travel-payment-portal ${className}`}>
      <PortalHeader />
      
      <div className="portal-main-content-enhanced">
        <div className="portal-content-enhanced">
          <TravelPaymentPortalSection
            onSubmit={handleLogin}
            onResetPasswordSubmit={handleResetPasswordSubmit}
            onDownloadGuide={handleDownloadGuide}
          />
          {loginError && (
            <div style={{
              color: '#DC3545',
              textAlign: 'center',
              marginTop: '16px',
              padding: '12px',
              backgroundColor: '#F8D7DA',
              border: '1px solid #F5C6CB',
              borderRadius: '4px'
            }}>
              {loginError}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TravelPaymentPortalComponent;